import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-ink-800" data-id="element-70" data-mp="x5mwum1ar1re">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-20" data-id="element-71" data-mp="123566dj87izx">
        <SectionLabel data-id="element-72" data-mp="1pro3jy0qmbd8">Preguntas frecuentes</SectionLabel>
        <h2 id="faq-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-73" data-mp="1puakgo9iq384">
          Todo lo que necesitas saber antes de decidir
        </h2>
        <div className="mt-10 space-y-3" data-id="element-74" data-mp="1g0jxxowyc2v2">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-ink-border bg-ink-card" data-id="element-75" data-mp="28q0m2adjgxlh" data-mpi={index}>
                <h3 data-id="element-76" data-mp="2opz4758tqg8n">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-ink-border/25" data-id="element-77" data-mp="2opfntsytnzwq">
                    <span className="text-[15px] font-bold text-white md:text-base" data-id="element-78" data-mp="37ff5husc2cq4">
                      {faq.question}
                    </span>
                    <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-greenDeep text-brand-green" data-id="element-79" data-mp="3hew9m7rxsijz">
                      {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={3} data-id="element-80" data-mp="1n1ev1a9iew13" /> : <PlusIcon className="h-4 w-4" strokeWidth={3} data-id="element-81" data-mp="1i3d2lyq71kcy" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5" data-id="element-82" data-mp="2bs1acre508tg">
                    <p className="border-t border-ink-border pt-4 text-[15px] leading-relaxed text-body" data-id="element-83" data-mp="2gqcimxosab9k">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}